import {gql, useLazyQuery} from '@apollo/client'

export const GET_TENANT_LIST_DATA = gql`
  query {
    tenantList {
      tenantListType {
        tenantName
        azureRole
      }
    }
  }
`

export default function useTenantList() {
  const [getTenantListData, {data, loading, error, refetch}] = useLazyQuery(GET_TENANT_LIST_DATA, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    errorPolicy: 'all'
  })
  return [getTenantListData, {data, loading, error, refetch}]
}
